<template lang="pug">
#more
  .head_menu.i_pt_8.i_pb_10
    .container.d-none.d-lg-flex.justify-content-between
      .left.flex_v
        .search
          ul
            li 熱門搜尋
            li.flex_h
              ul.search_item(
                v-if="index % 3 == 0",
                v-for="(word, index) in hotKeyword.HotKeywordList"
              )
                li(
                  v-for="(word, sonIndex) in hotKeyword.HotKeywordList",
                  v-if="sonIndex >= index && sonIndex < index + 3"
                )
                  p(
                    v-if="word.HotKeywordProductJson == '-1'",
                    @click="toCustomize(word.CustomizeJson)"
                  ) {{ word.HotKeywordTitle }}
                  p(v-else, @click="toProduct(word.HotKeywordProductJson)") {{ word.HotKeywordTitle }}
        .options.flex_h
          ul
            li 網站導覽與聲明
            li
              p(@click="toPage('Sitemap')") 網站地圖
            li
              p(@click="toPage('CustomerProtectionStatement')") 客戶保護及聲明事項
            li
              p(@click="toCustomize('Trafficsafetyzone')") 交通安全宣導專區
            li
              p(@click="toUrl('https://easyaccess.tmnewa.com.tw/')") 友善服務網站

          ul
            li 加入我們
            li
              p(
                @click="toUrl('https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1')"
              ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
      .right.d-flex.justify-content-between
        //- ul
        //-   li 網路投保
        //-   li(v-for="link in siteMap.WebInsuredList")
        //-     p(@click="toUrl(link.URL)") {{ link.Name }}
        ul
          li 商品櫥窗
          li(v-for="product in productCategory.ProductCategoryList") 
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            p(@click="toPageWindow(product)") {{ product.ProductCategoryName }}
        ul
          li 客戶服務
          li
            p(@click="toPage('CustomerServiceClaimSettlement')") 理賠服務
          li
            p(@click="toPage('CustomerServicePaymentService')") 繳費服務
          li
            p(@click="toPage('CustomerServiceDamagePrevention')") 損害防阻服務
          li
            p(@click="toPage('CustomerServiceEInsurance')") 電子保單下載
          li
            p(@click="toPage('CustomerServiceCompulsoryLicense')") 強制證下載
          li
            p(@click="toPage('CustomerServiceFAQ')") 常見問題
          li
            p(@click="toPage('CustomerServiceDocumentDownload')") 文件下載
          //- li(v-if="false")
          li
            p(@click="toPage('CustomerServiceSignLanguage')") 手譯服務
          li
            p(@click="toPage('CustomerServiceMultiLanguage')") 多國語言服務
        ul
          li 認識我們
          li
            p(@click="toPage('AboutUsProfile')") 公司簡介
          li
            p(@click="toPage('AboutUsSocialResponsibility')") 永續發展
          li
            p(@click="toPage('AboutUsPublicInfo')") 公開資訊
          li
            p(@click="toPage('AboutUsGovernance')") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li
            p(@click="toPage('AboutUsNews')") 最新消息
          li
            p(@click="toPage('CustomerServiceContactUs')") 商業合作
          li
            p(@click="toPage('ShareholderServices')") 股東專區
          li
            a(href="/customize/manager") 公平待客
        .last_list.d-flex.flex-column.justify-content-between
          ul
            li 友站連結
            li(v-for="link in siteMap.LinkList")
              p(@click="toUrl(link.URL)") {{ link.Name }}
          ul.lang
            li
              svg-icon.i_ml_1.i_ml_md_0.i_ml_sm_1(
                iconClass="lang",
                className="lang_icon"
              )
              span 切換網站顯示語言
            li
              a(href="/") 中文
              |&nbsp;/&nbsp;
              a(href="/japanese/") 日本語
              |&nbsp;/&nbsp;
              a(href="/english/") EN
    .container.d-lg-none
      .group.d-flex
        ul.d-none.d-md-block
          li 熱門搜尋
            li(v-for="word in hotKeyword.HotKeywordList")
              p(
                v-if="word.HotKeywordProductJson == '-1'",
                @click="toCustomize(word.CustomizeJson)"
              ) {{ word.HotKeywordTitle }}
              p(v-else, @click="toProduct(word.HotKeywordProductJson)") {{ word.HotKeywordTitle }}
        //- ul
        //-   li 網路投保
        //-   li(v-for="link in siteMap.WebInsuredList")
        //-     p(@click="toUrl(link.URL)") {{ link.Name }}
        ul
          li 商品櫥窗
          li(v-for="product in productCategory.ProductCategoryList") 
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            |
            p(@click="toPageWindow(product)") {{ product.ProductCategoryName }}
        ul
          li 客戶服務
          li
            p(@click="toPage('CustomerServiceClaimSettlement')") 理賠服務
          li
            p(@click="toPage('CustomerServicePaymentService')") 繳費服務
          li
            p(@click="toPage('CustomerServiceDamagePrevention')") 損害防損
          li
            p(@click="toPage('CustomerServiceEInsurance')") 電子保單下載
          li
            p(@click="toPage('CustomerServiceCompulsoryLicense')") 強制證下載
          li
            p(@click="toPage('CustomerServiceFAQ')") 常見問題
          li
            p(@click="toPage('CustomerServiceDocumentDownload')") 文件下載
          li
            p(@click="toPage('CustomerServiceSignLanguage')") 手譯服務
          li
            p(@click="toPage('CustomerServiceMultiLanguage')") 多國語言服務
        ul.d-none.d-md-block
          li 認識我們
          li
            p(@click="toPage('AboutUsProfile')") 公司簡介
          li
            p(@click="toPage('AboutUsSocialResponsibility')") 永續發展
          li
            p(@click="toPage('AboutUsPublicInfo')") 公開資訊
          li
            p(@click="toPage('AboutUsGovernance')") 公司治理
          li
            a(href="/customize/Stewardship") 盡職治理
          li
            p(@click="toPage('AboutUsNews')") 最新消息
          li
            p(@click="toPage('CustomerServiceContactUs')") 商業合作
          li
            p(@click="toPage('ShareholderServices')") 股東專區
          li
            a(href="/customize/manager") 公平待客
        ul.d-none.d-md-block
          li 加入我們
          li
            p(
              @click="toUrl('https://www.104.com.tw/company/7qey3yw?jobsource=n104bank1')"
            ) 菁英招募
            li
              a(href="https://www.facebook.com/tmnewa", target="_blank")
                font-awesome-icon(:icon="['fab', 'facebook-square']")
            li
              a(
                href="https://www.youtube.com/channel/UCmfkEx42CLQFVF0r1PYsojg",
                target="_blank"
              )
                font-awesome-icon(:icon="['fab', 'youtube']")
        ul.d-none.d-md-block
          li 網站導覽與聲明
          li
            p(@click="toPage('Sitemap')") 網站地圖
          li
            p(@click="toPage('CustomerProtectionStatement')") 客戶保護及聲明事項
          li
            p(@click="toCustomize('Trafficsafetyzone')") 交通安全宣導專區
          li
            a(href="https://easyaccess.tmnewa.com.tw/", target="_blank") 友善服務網站
        ul.d-md-none
          li 熱門搜尋
            li(v-for="word in hotKeyword.HotKeywordList")
              p(
                v-if="word.HotKeywordProductJson == '-1'",
                @click="toCustomize(word.CustomizeJson)"
              ) {{ word.HotKeywordTitle }}
              p(v-else, @click="toProduct(word.HotKeywordProductJson)") {{ word.HotKeywordTitle }}
        .last_list.d-flex.flex-column.justify-content-between
          ul.d-none.d-md-block
            li 友站連結
            li(v-for="link in siteMap.LinkList")
              p(@click="toUrl(link.URL)") {{ link.Name }}
          ul.lang.text-center.text-md-left
            li.d-none.d-md-block
              svg-icon.i_ml_1.i_ml_md_0.i_ml_sm_1(
                iconClass="lang",
                className="lang_icon"
              )
              span 切換網站顯示語言
            li
              svg-icon.d-md-none.i_ml_1.i_ml_md_0.i_ml_sm_1(
                iconClass="lang",
                className="lang_icon"
              )
              a(href="/") 中文
              |&nbsp;/&nbsp;
              a(href="/japanese/") 日本語
              |&nbsp;/&nbsp;
              a(href="/english/") EN
</template>

<script>
import { getSiteMap, getHotKeyword } from "@/json/menu";
import { getProductCategory } from "@/json/product";

export default {
  name: "More",
  data() {
    return {
      siteMap: {},
      hotKeyword: {},
      productCategory: {},
      links: [
        {
          name: "商品櫥窗",
          isExpand: false,
          pageName: "Product",
          children: [
            {
              name: "汽車險",
              isExpand: false,
              list: [
                { name: "強制險", url: "/product/intro/1" },
                { name: "第三人責任險", url: "/product/intro/2" },
                { name: "車體險", url: "/product/intro/3" },
                { name: "竊盜險", url: "/product/intro/4" },
                { name: "超額責任險", url: "/product/intro/5" },
                { name: "乘客體傷責任險", url: "/product/intro/7" },
              ],
            },
            {
              name: "機車險",
              isExpand: false,
              list: [
                { name: "強制險", url: "/product/intro/8" },
                { name: "車體險", url: "/product/intro/9" },
                { name: "竊盜險", url: "/product/intro/10" },
                { name: "第三人責任險", url: "/product/intro/11" },
                { name: "駕駛人傷害險", url: "/product/intro/12" },
                { name: "機車乘客體傷責任險", url: "/product/intro/13" },
              ],
            },
            {
              name: "住宅險",
              isExpand: false,
              list: [
                {
                  name: "住宅火災及地震基本保險",
                  url: "/product/intro/14",
                },
                {
                  name: "住宅火災及地震綜合保險",
                  url: "/product/intro/15",
                },
                {
                  name: "住宅火災及日常生活責任綜合保險",
                  url: "/product/intro/16",
                },
                {
                  name: "居家綜合保險",
                  url: "/product/intro/17",
                },
              ],
            },
            {
              name: "旅遊險",
              isExpand: false,
              list: [
                { name: "旅遊平安險", url: "/product/intro/18" },
                { name: "傷害醫療保險", url: "/product/intro/19" },
                { name: "信用卡綜合保險", url: "/product/intro/40" },
              ],
            },
            {
              name: "傷害險",
              isExpand: false,
              list: [
                { name: "新快樂童年", url: "/product/intro/25" },
                { name: "新老來保", url: "/product/intro/27" },
              ],
            },
            {
              name: "健康險",
              isExpand: false,
              list: [
                { name: "全心防癌", url: "/product/intro/30" },
                { name: "三高心安保", url: "/product/intro/31" },
              ],
            },
            {
              name: "企業保險",
              isExpand: false,
              list: [
                { name: "商業火險", url: "/product/intro/32" },
                { name: "工程保險", url: "/product/intro/33" },
                { name: "責任保險", url: "/product/intro/34" },
                { name: "海上保險", url: "/product/intro/35" },
              ],
            },
          ],
        },
        {
          name: "客戶服務",
          isExpand: false,
          pageName: "CustomerService",
          children: [
            { name: "理賠服務", url: "/customerservice/claimsettlement" },
            { name: "繳費服務", url: "/customerservice/paymentservice" },
            { name: "損害防阻", url: "/customerservice/damageprevention" },
            { name: "電子保單下載", url: "/customerservice/einsurance" },
            { name: "強制證下載", url: "/customerservice/compulsorylicense" },
            { name: "常見問題", url: "/customerservice/faq" },
            { name: "文件下載", url: "/customerservice/documentdownload" },
            { name: "手譯服務", url: "/customerservice/signlanguage" },
            { name: "多語翻譯服務", url: "/customerservice/multilanguage" },
          ],
        },
        {
          name: "認識我們",
          isExpand: false,
          pageName: "AboutUs",
          children: [
            { name: "公司簡介", url: "/aboutus/profile" },
            { name: "公司治理", url: "/aboutus/governance" },
            { name: "永續發展", url: "/aboutus/socialresponsibility" },
            { name: "公開資訊", url: "/aboutus/publicinfo" },
            { name: "最新消息", url: "/aboutus/news" },
            { name: "盡職治理", url: "/aboutus/Stewardship" },
          ],
        },
        {
          name: "公平待客",
          isExpand: false,
          url: "/customize/manager",
          children: [
            { name: "總經理的話", url: "/customize/manager" },
            { name: "關於公平待客", url: "/customize/about" },
            { name: "新安東京海上的公平待客", url: "/customize/clientsfairly" },
            { name: "金融友善服務專區", url: "/customize/financial" },
          ],
        },
      ],
    };
  },
  created() {
    this.getSiteMap();
    this.getHotKeyword();
    this.getProductCategory();
  },
  methods: {
    toggleGroup(gi) {
      this.$set(this.links[gi], "isExpand", !this.links[gi].isExpand);
    },
    toggleChild({ gi, ci }) {
      const node = this.links[gi]?.children?.[ci];
      if (!node) return;
      this.$set(node, "isExpand", !node.isExpand);
    },
    toPage(pageName) {
      this.$router.push({ name: pageName });
      this.$emit("menuExpand", false);
    },
    toUrl(url) {
      window.open(url);
      this.$emit("menuExpand", false);
    },
    getSiteMap() {
      getSiteMap().then((response) => {
        this.siteMap = response.data;
      });
    },
    getHotKeyword() {
      getHotKeyword().then((response) => {
        this.hotKeyword = response.data;
      });
    },
    getProductCategory() {
      getProductCategory().then((response) => {
        this.productCategory = response.data;
      });
    },
    toContactUs() {
      this.$router.push({ name: "CustomerServiceContactUs" });
      this.$emit("menuExpand", false);
    },
    toProduct(productJson) {
      this.$router.push({
        name: "ProductIntro",
        params: {
          type: productJson,
        },
      });
      if ("ProductIntro" == this.$route.name) {
        this.$emit("footerProductClick");
      }
      this.$emit("menuExpand", false);
    },
    toPageWindow(product) {
      if (product && product.ProductList.length > 0) {
        this.$router.push({
          name: "ProductIntro",
          params: {
            type: product.ProductList[0].ProductJson,
          },
        });
        if ("ProductIntro" == this.$route.name) {
          this.$emit("footerProductClick");
        }
        this.$emit("menuExpand", false);
      }
    },
    toCustomize(customizeJson) {
      this.$router.push({
        name: "Customize",
        params: {
          page: customizeJson,
        },
      });
      this.$emit("menuExpand", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/more";
</style>